"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allMasterStates = exports.defaultStyle = void 0;
const defaultFontSize = "9.33334px";
exports.defaultStyle = {
    color: "#555",
    margin: [0, 10],
    fontSize: defaultFontSize,
    lineHeight: 1.2
};
const columnGap = 10;
const formatTableColumnText = (textContent) => ({
    table: {
        widths: ["*"],
        body: [
            [
                {
                    columnGap,
                    columns: [
                        {
                            text: textContent
                        }
                    ]
                }
            ]
        ]
    }
});
const defaultUrsusInformation = [
    {
        text: "Ursus Insurance Services, Inc. \n"
    },
    {
        text: "470 James St., STE 7, \n"
    },
    {
        text: "New Haven, CT, 06513 \n"
    }
];
exports.allMasterStates = [
    {
        country: "USA",
        state: "AL",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This contract is registered and delivered as surplus line coverage under the Alabama Surplus Line Insurance Law",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "AK",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "This is evidence of insurance procured and developed under the Alaska Surplus Lines Law, AS 21.34. It is not covered by the Alaska Insurance Guaranty Association Act, AS 21.80. This insurer  does not hold a certificate of authority issued by this state and is not subject to its supervision, and, in the event of the insolvency of the surplus lines insurer, losses will not be covered under AS 21.80 (Alaska Insurance Guaranty Association Act).\n\n",
                alignment: "justify"
            },
            {
                text: "Approved Policyholder Notice - “This policy is issued by a nonadmitted or surplus lines insurer. Insurance may only be purchased from nonadmitted insurers if the full amount, kind, or class of insurance cannot be obtained from insurers who are admitted to do business in the State of Alaska. Your broker or the surplus lines broker has determined that this was true on the date the policy was placed. Before issuing a renewal policy or extending this policy, remarketing is required. To avoid intentional or unintentional extension of coverage in the surplus lines market when an admitted market for that coverage exists, a nonadmitted insurer is prohibited from the automatic renewal or extension of a policy without remarketing by your broker or the surplus lines broker”.\n\n",
                alignment: "justify"
            },
            {
                text: "In order to comply with the Alaska Administrative Code, the following notice is given:\n\n",
                alignment: "justify"
            },
            {
                text: "“You are hereby notified that, under 3 AAC 25.050, your policy will terminate effective no later than the date and time of its expiration. We reserve the right to cancel this policy sooner than the expiration date by giving you notice of cancellation as required in AS 21.36.220. You may request through your broker that a new policy from the surplus lines broker be concurrent with the effective date of the termination of this policy. You are also notified that a new policy, if issued by us, is subject to rerating, which may result in a premium increase of more than ten percent (10%). As required by 3 AAC 25.050, you are hereby notified that any subsequent policy issued by us may be subject to a ten percent (10%) or more increase in premium. The actual premium will be based upon rates that apply at the time a subsequent policy, if any, is issued and will be made available to you before the effective date of the new policy, or the date subsequent coverage is bound, whichever occurs first.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "AZ",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "Pursuant to section 20-401.01, subsection B, paragraph 1, Arizona Revised Statutes, this policy is issued by an insurer that does not possess a certificate of authority from the director of the Arizona Department of Insurance and Financial Institutions. If the insurer that issued this policy becomes insolvent, insureds or claimants will not be eligible for insurance guaranty fund protection pursuant to title 20, Arizona Revised Statutes.",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "AR",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This contract is registered and delivered as a surplus line coverage under the Surplus Lines Insurance Law, and it may in some respects be different from contracts issued by insurers in the admitted markets, and, accordingly, it may, depending upon the circumstances, be more or less favorable to an insured than a contract from an admitted carrier might be. The protection of the Arkansas Property and Casualty Guaranty Act does not apply to this contract. A tax of four percent (4%) is required to be collected from the insured on all surplus lines premiums.  \n A.C.A. § 23-65-307.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "CA",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "21px" }), formatTableColumnText([
            {
                text: "IMPORTANT NOTICE: \n\n",
                bold: true
            },
            {
                text: "1. The insurance policy that you [have purchased] [are applying to purchase] is being issued by an insurer that is not licensed by the State of California. These companies are called “nonadmitted” or “surplus line” insurers. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "2. The insurer is not subject to the financial solvency regulation and enforcement that apply to California licensed insurers. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "3. The insurer does not participate in any of the insurance guarantee funds created by California law. Therefore, these funds will not pay your claims or protect your assets if the insurer becomes insolvent and is unable to make payments as promised. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "4. The insurer should be licensed either as a foreign insurer in another state in the United States or as a non-United States (alien) insurer. You should ask questions of your insurance agent, broker, or “surplus line” broker or contact the California Department of Insurance at thetoll-free number 1-800-927-4357  or internet website www.insurance.ca.gov. Ask whether or not the insurer is licensed as a foreign or non-United States (alien) insurer and for additional information about the insurer. You may also visit the NAIC’s internet website at www.naic.org. The NAIC—the National Association of Insurance Commissioners—is the regulatory support organization created and governed by the chief insurance regulators in the United States. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "5. Foreign insurers should be licensed by a state in the United States and you may contact that state’s department of insurance to obtain more information about that insurer. You can find a link to each state from this NAIC internet website: https://naic.org/state_web_map.htm. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "6. For non-United States (alien) insurers, the insurer should be licensed by a country outside of the United States and should be on the NAIC’s International Insurers Department (IID) listing of approved nonadmitted non-United States insurers. Ask your agent, broker, or “surplus line” broker to obtain more information about that insurer. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "7. California maintains a “List of Approved Surplus Line Insurers (LASLI).” Ask your agent or broker if the insurer is on that list, or view that list at the internet websiteof the California Department of Insurance:  www.insurance.ca.gov/01-consumers/120-company/07-lasli/lasli.cfm. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "8. If you, as the applicant, required that the insurance policy you have purchased be effective immediately, either because existing coverage was going to lapse within two business days or because you were required to have coverage within two business days, and you did not receive this disclosure form and a request for your signature until after coverage became effective, you have the right to cancel this policy within five days of receiving this disclosure. If you cancel coverage, the premium will be prorated and any broker’s fee charged for this insurance will be returned to you. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "B. The disclosure form must be signed and dated by the applicant or policyholder. The surplus lines broker and nonadmitted insurer may rely upon a signed copy of the disclosure received from the producing agent licensee (the retailer).  \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "Insured's Signature "
            },
            {
                text: "                                        ",
                decoration: "underline"
            }
        ]))
    },
    {
        country: "USA",
        state: "CO",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This contract is delivered as a surplus line coverage under the 'Nonadmitted Insurance Act'. The insurer issuing this contract is not licensed in Colorado but is an eligible nonadmitted insurer. There is no protection under the provisions of the 'Colorado Insurance Guaranty Association Act'. \n\n",
                alignment: "justify"
            },
            {
                text: "Policies on property or operations temporarily or permanently located outside U.S. - “This policy is issued by an insurance company that is not regulated by the Colorado Division of Insurance. The insurance company may not provide claims service and may not be subject to service of process in Colorado. If the insurance company becomes insolvent, insureds or claimants will not be eligible for protection under Colorado insurance law.”",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "CT",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "16px" }), formatTableColumnText([
            {
                text: "NOTICE: THIS IS A SURPLUS LINES POLICY AND IS NOT PROTECTED BY THE CONNECTICUT INSURANCE GUARANTY ASSOCIATION OR SUBJECT TO REVIEW BY THE CONNECTICUT INSURANCE DEPARTMENT. IT IS IMPORTANT THAT YOU READ AND UNDERSTAND THIS POLICY.",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "DE",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This insurance contract is issued pursuant to the Delaware Insurance Laws by an insurer neither licensed by nor under the jurisdiction of the Delaware Insurance Department. This insurer does not participate in insurance guaranty funds created by state law. In the event of the insolvency of the surplus lines insurer, losses will not be paid by the state insurance guaranty fund.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "DC",
        variables: []
    },
    {
        country: "USA",
        state: "FL",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "14px" }), formatTableColumnText([
            {
                text: "THIS INSURANCE IS ISSUED PURSUANT TO THE FLORIDA SURPLUS LINES LAW. PERSONS INSURED BY SURPLUS LINES CARRIERS DO NOT HAVE THE PROTECTION OF THE FLORIDA INSURANCE GUARANTY ACT TO THE EXTENT OF ANY RIGHT OF RECOVERY FOR THE OBLIGATION OF AN INSOLVENT UNLICENSED INSURER. \n\n",
                alignment: "justify",
                bold: false
            },
            {
                text: "SURPLUS LINES INSURERS’ POLICY RATES AND FORMS ARE NOT APPROVED BY ANY FLORIDA REGULATORY AGENCY. \n\n",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "GA",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { pageBreak: "before" }), formatTableColumnText([
            {
                text: "This contract is registered and delivered as a surplus line coverage under the Surplus Line Insurance Law, O.C.G.A. Chapter 33-5. \n\n"
            },
            {
                text: "FREQUENTLY ASKED QUESTIONS \n\n",
                bold: true,
                alignment: "center"
            },
            {
                text: "ABOUT YOUR SURPLUS LINES POLICY \n\n",
                bold: true,
                alignment: "center"
            },
            {
                text: "Your broker has placed the insurance you requested in the 'surplus lines market' with one or more surplus lines insurers. By definition, such surplus lines insurers are not licensed in the state, but this does not mean that the transaction is not regulated. The surplus lines market is an insurance marketplace that is established for the purpose of insuring unique or hard to place risks. Some of the rules that apply to surplus lines insurance policies and surplus lines insurance companies differ from those that govern coverage obtained from insurance companies licensed in your state. In order for you to better understand the surplus lines market and the rights you have in a surplus lines transaction, the following material is provided. \n\n",
                alignment: "justify"
            },
            {
                text: "Please read this brochure carefully, and should you have any questions after reading the material, do not hesitate to ask your broker. If you wish further information, please contact the Regulatory Services Division, Room 604 West Tower, 2 Martin Luther King, Jr. Drive, Atlanta, Georgia 30334 or (404) 656-2074 or toll free at (800) 656-2298 (request Regulatory Services Division). \n \n",
                alignment: "justify"
            },
            {
                text: "WHAT IS A SURPLUS LINES POLICY? \n\n",
                bold: true
            },
            {
                text: "A surplus lines policy is a policy placed with an insurer that is not licensed (or 'admitted') in this state, but is nonetheless eligible to provide insurance on property or liability insurance protection to citizens of this state through specially licensed agents or brokers known as surplus lines brokers. \n \n",
                alignment: "justify"
            },
            {
                text: "WHY AM I GETTING COVERAGE FROM A SURPLUS LINES INSURER? \n\n",
                bold: true
            },
            {
                text: "Your agent or broker may have been unable to obtain the coverage you requested from insurance companies licensed in this state, but was able to obtain coverage from an eligible surplus lines insurance company. The reason for your agent or broker's action is that the risk or property for which you sought coverage may be unique or have certain risk characteristics that caused licensed insurers to decline to write the policy. In circumstances where licensed insurers will not write the risk, your broker is authorized by state law or regulation to obtain the coverage from a “surplus lines” insurer. \n \n",
                alignment: "justify"
            },
            {
                text: "SINCE THE SURPLUS LINES INSURER IS UNLICENSED, IS THE TRANSACTION UNREGULATED? \n\n",
                bold: true
            },
            {
                text: "Surplus lines transactions are regulated by state law that require that surplus lines policies be procured only by specially licensed brokers. These are called surplus lines brokers and they are authorized to transact business with certain unlicensed insurers that meet financial and other eligibility standards set by the state. These insurers are known as surplus lines insurers. Your agent may have worked with a licensed surplus lines broker in securing your policy. Alternatively, your agent may hold a surplus lines broker's license. \n \n",
                alignment: "justify"
            },
            {
                text: "IS MY SURPLUS LINES POLICY COVERED BY THE STATE GUARANTY OR INSOLVENCY FUND? \n\n",
                bold: true
            },
            {
                text: "No. There is no guaranty fund for coverage for surplus lines policies. The guaranty fund, which provides payments in the event that your insurance company becomes insolvent, only covers policies of licensed insurers. \n \n",
                alignment: "justify"
            },
            {
                text: "HOW IS THE RATE OR PRICE OF A SURPLUS LINES POLICY DETERMINED? \n\n",
                bold: true
            },
            {
                text: "The rate or premium charged for a surplus lines policy is determined by the surplus lines insurer. As unlicensed insurers, surplus lines insurers do not file their rates or premiums with the state for review or approval. \n \n",
                alignment: "justify"
            },
            {
                text: "DOES THE GEORGIA DEPARTMENT OF INSURANCE REVIEW OR APPROVE THE TERMS AND CONDITIONS OF THIS POLICY? \n\n",
                bold: true
            },
            {
                text: "Pursuant to O.C.G.A. § 33-5-21.1, policies of surplus lines insurers are not reviewed or approved by the Georgia Department of Insurance. \n \n",
                alignment: "justify"
            },
            {
                text: "CAN MY POLICY BE RENEWED OR EXTENDED? \n\n",
                bold: true
            },
            {
                text: "Your surplus lines policy may or may not be renewed or extended when the policy expires. An extension of the policy coverage will be dependent upon the continued unavailability of the policy coverage from insurers licensed in this state and the willingness of the surplus lines insurer to continue to accept the risk. Since a surplus lines policy is generally not subject to the same notice requirements as a policy issued by a licensed insurer, notice of a premium increase for a new policy term or the company's intent not to extend the policy at the same terms and conditions might not be provided until close to the date the policy expires. Therefore, you should keep in contact with your agent or broker, particularly as the expiration of the policy term nears, to ascertain the status of the policy and to assure continuity of coverage. \n \n",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "HI",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This insurance contract is issued by an insurer which is not licensed by the State of Hawaii and is not subject to its regulation or examination. If the insurer is found insolvent, claims under this contract are not covered by any guaranty fund of the State of Hawaii.” \n\n",
                alignment: "justify"
            },
            ...defaultUrsusInformation,
            {
                text: "303-578-2440 \n"
            },
            {
                text: "Email: nathan.trimble@loadsure.net \n"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "ID",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "“This surplus line contract is issued pursuant to the Idaho insurance laws by an insurer not licensed by the Idaho Department of Insurance. There is no coverage provided for surplus line insurance by either the Idaho Insurance Guaranty Association or by the Idaho Life and Health Insurance Guaranty Association.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "IL",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "16px" }), formatTableColumnText([
            {
                text: "Notice to Policyholder: \n \n This contract is issued, pursuant to Section 445 of the Illinois Insurance Code, by a company not authorized and licensed to Transact business in Illinois and as such is not covered by the Illinois Insurance Guaranty Fund. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "Except for exempt coverages, Illinois transaction number must be on the policy prior to delivery to the insured.",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "IN",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "21px" }), formatTableColumnText([
            {
                text: "PRIVACY NOTE \n \nNEITHER THE U.S. SURPLUS LINES AGENTS THAT HANDLED THIS INSURANCE NOR THE INSURERS THAT HAVE UNDERWRITTEN THIS INSURANCE WILL DISCLOSE NONPUBLIC PERSONAL INFORMATION CONCERNING THE BUYER TO NONAFFILIATES OF THE BROKERS OR INSURERS EXCEPT AS PERMITTED BY LAW.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "IA",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This policy is issued, pursuant to Iowa Code chapter 515I, by an eligible surplus lines insurer in Iowa and as such is not covered by the Iowa Insurance Guaranty Association.”",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "KS",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This policy is issued by an insurer not authorized to do business in Kansas and, as such, the form, financial condition and rates are not subject to review by the commissioner of insurance and the insured is not protected by any guaranty fund” \n\n",
                alignment: "justify"
            },
            {
                text: "(1) A statement that the coverage will be obtained from an insurer not authorized to do business in this state; (2) a statement that the insurer's name appears on the list of companies maintained by the commissioner pursuant to K.S.A. 40-246e, and amendments thereto; (3) a notice that the insurer's financial condition, policy forms, rates and trade practices are not subject to the review or jurisdiction of the commissioner; (4) a statement that the protection of the guaranty associations is not afforded to policyholders of the insurer; and (5) a statement or notice with respect to any other information deemed necessary by the commissioner pertinent to insuring with an insurer not authorized to do business in this state. The commissioner may revoke or suspend any license issued pursuant to the provisions of this act in the same manner and for the same reasons prescribed by K.S.A. 2017 Supp. 40-4909, and amendments thereto.",
                alignment: "justify"
            }
        ])),
        insuranceLicenseSignature: true
    },
    {
        country: "USA",
        state: "KY",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This insurance has been placed with an insurer not licensed to transact business in the Commonwealth of Kentucky but eligible as a surplus lines insurer. The insurer is not a member of the Kentucky Insurance Guaranty Association. Should the insurer become insolvent, the protection and benefits of the Kentucky Insurance Guaranty Association are not available.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "LA",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "NOTICE \n \n This insurance policy is delivered as surplus lines coverage under the Louisiana Insurance Code. \n In the event of insolvency of the company issuing this contract, the policyholder or claimant is not covered by the Louisiana Insurance Guaranty Association or the Louisiana Life and Health Insurance Guaranty Association, which guarantees only specific types of policies issued by insurance companies authorized to do business in Louisiana. \n This surplus lines policy has been procured by the following licensed Louisiana surplus lines broker:",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "ME",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "“This insurance contract is issued pursuant to the Maine Insurance Laws by an insurer neither licensed by nor under the jurisdiction of the Maine Bureau of Insurance.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "MD",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "18px" }), formatTableColumnText([
            {
                text: "“This insurance is issued by a nonadmitted insurer not under the jurisdiction of the Maryland Insurance Commissioner” \n \n \n \n \n \n \n",
                bold: true
            },
            {
                text: "DISCLOSURE REGARDING SURPLUS LINES INSURANCE \n \n"
            },
            {
                text: "Please Read the Following Carefully Before Purchasing Insurance From a Surplus Lines Insurer. \n \n",
                alignment: "justify"
            },
            {
                text: "This policy is issued by a surplus lines insurer that has been approved by the Maryland Insurance Administration to issue insurance policies in the surplus lines insurance market. Surplus lines insurers are not under the jurisdiction of the Maryland Insurance Administration and do not possess a certificate of authority to transact insurance business in the State of Maryland. Because surplus lines insurers are not under the jurisdiction of the Maryland Insurance Administration, your ability to seek assistance from the State if you have a problem with your insurance company is limited. \n \n",
                alignment: "justify"
            },
            {
                text: "Property and Casualty Insurance Guaranty Corporation and Maryland  Life and Health Insurance Guaranty Corporation provide funds that permit certain claimants or policyholders to receive payment of covered claims if their insurance company becomes insolvent (i.e., bankrupt) and is unable to pay the claims. However, these funds do not apply to surplus lines insurers, as a surplus lines insurer is not a member insurer of the Property and Casualty Insurance Guaranty Corporation or the Maryland Life and Health Insurance Guaranty Corporation. If a surplus lines insurer becomes insolvent (i.e. bankrupt), any claim that you have against the surplus lines insurer will not be covered by the funds administered by Property and Casualty Insurance Guaranty Corporation and Maryland Life and Health Insurance Guaranty Corporation. \n \n",
                alignment: "justify"
            },
            {
                text: "If you have any questions regarding this disclosure or surplus lines insurance, please contact the Maryland Insurance Administration at 410-468-2340.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "MA",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This policy is insured by a company which is not admitted to transact insurance in the commonwealth, is not supervised by the commissioner of insurance and, in the event of an insolvency of such company, a loss shall not be paid by the Massachusetts Insurers Insolvency Fund under chapter 175D. \n\n",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "MI",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px", color: "#FF0000" }), formatTableColumnText([
            {
                text: "This insurance has been placed with an insurer that is not licensed by the state of Michigan. In case of insolvency, payment of claims may not be guaranteed.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "MN",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "THIS INSURANCE IS ISSUED PURSUANT TO THE MINNESOTA SURPLUS LINES INSURANCE ACT. THE INSURER IS AN ELIGIBLE SURPLUS LINES INSURER BUT IS NOT OTHERWISE LICENSED BY THE STATE OF MINNESOTA. IN CASE OF INSOLVENCY, PAYMENT OF CLAIMS IS NOT GUARANTEED.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "MS",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "NOTE: This insurance policy is issued pursuant to Mississippi law covering surplus lines insurance. The company issuing the policy is not licensed by the State of Mississippi, but is authorized to do business in Mississippi as a nonadmitted company. The policy is not protected by the Mississippi Insurance Guaranty Association in the event of the Insurer's Insolvency.",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "MO",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "This is evidence of insurance procured and developed under the Missouri Surplus Lines Laws. It is NOT covered by the Missouri Insurance Guaranty Association. This insurer is not licensed by the state of Missouri and is not subject to its supervision.",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "MT",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "NOTICE: This coverage is issued by an unauthorized insurer that is an eligible surplus lines insurer. If this insurer becomes insolvent, there is no coverage by the Montana Insurance Guaranty Association under the Montana Insurance Guaranty Association Act.",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true,
        insuranceLicenseSignature: true
    },
    {
        country: "USA",
        state: "NE",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This policy is issued by a nonadmitted insurer, and in the event of the insolvency of such insurer, this policy will not be covered by the Nebraska Property and Liability Insurance Guaranty Association. \n\n",
                alignment: "justify"
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true,
        insuranceLicenseSignature: true
    },
    {
        country: "USA",
        state: "NV",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This insurance contract is issued pursuant to the Nevada insurance laws by an insurer neither licensed by nor under the supervision of the Division of Insurance of the Department of Business and Industry of the State of Nevada. If the insurer is found insolvent, a claim under this contract is not covered by the Nevada Insurance Guaranty Association Act.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "NH",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "The company issuing this policy is an eligible surplus lines insurer in the state of New Hampshire and the rates charged and policy forms used have not been approved by the commissioner of insurance. If the company issuing this policy becomes insolvent, the New Hampshire insurance guaranty fund shall not be liable for any claims made against the policy.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "NJ",
        variables: ["stateLicenseNumber"],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "Exportable. This Insurance is Issued Pursuant to the New Jersey Surplus Lines Law. \n \n",
                alignment: "justify"
            },
            {
                text: "This policy is written by a surplus lines insurer and is not subject to the filing or approval requirements of the New Jersey Department of Banking and Insurance. Such a policy may contain conditions, limitations, exclusions and different terms than a policy issued by an insurer granted a Certificate of Authority by the New Jersey Department of Banking and Insurance. The insurer has been approved by the Department as an eligible surplus lines insurer, but the policy is not covered by the New Jersey Insurance Guaranty Fund, and only a policy of medical malpractice liability insurance as defined in N.J.S.A. 17:30D-3d or a policy of property insurance covering owner-occupied dwellings of less than four dwelling units are covered by the New Jersey Surplus Lines Guaranty Fund. \n \n",
                alignment: "justify"
            },
            {
                text: "The undersigned applicant has been advised by the undersigned originating insurance producer and understands that an insurance policy written by a surplus lines insurer is not subject to the filing or approval requirements of the New Jersey Department of Banking and Insurance. Such a policy may contain conditions, limitations, exclusions and different terms than a policy issued by an insurer granted a Certificate of Authority by the New Jersey Department of Banking and Insurance. \n\n",
                alignment: "justify"
            },
            {
                text: "Exhibit A-1 - The undersigned applicant has been advised by the undersigned originating insurance producer and understands that an insurance policy written by a surplus lines insurer is not subject to the filing or approval requirements of the New Jersey Department of Banking and Insurance. Such a policy may contain conditions, limitations and different terms than a policy issued by an insurer granted a Certificate of Authority by the New Jersey Department of Banking and Insurance. \n\n",
                alignment: "justify"
            },
            {
                text: "Applicant's Signature: ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "Applicant's Name (Print or Type): ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "Date of Applicant's Signature: ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "Producer Signature: ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "Producer Name (Print or Type): ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "Date of Producer Signature: ",
                alignment: "justify"
            },
            {
                text: "                                        \n\n",
                decoration: "underline"
            },
            {
                text: "New Jersey Producer License Reference Number: %stateLicenseNumber%"
            }
        ])),
        insuranceLicenseName: true,
        insuranceLicenseSignature: true
    },
    {
        country: "USA",
        state: "NM",
        variables: [
            "masterPolicyId",
            "assuredName",
            "certificateNumber",
            "purchasedDate",
            "underwriterName"
        ],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "“This policy provides surplus lines insurance by an insurer not otherwise authorized to transact business in New Mexico. This policy is not subject to supervision, review or approval by the superintendent of insurance. The insurance so provided is not within the protection of any guaranty fund law of New Mexico designed to protect the public in the event of the insurer’s insolvency.” \n \n",
                alignment: "justify",
                bold: true
            },
            {
                text: "THIS ENDORSEMENT MUST BE ATTACHED TO THE POLICY \n \n",
                alignment: "justify",
                bold: true
            },
            {
                text: "AS PART OF THE INSURANCE CONTRACT \n \n",
                alignment: "justify",
                bold: true
            },
            {
                text: "This policy provides surplus lines insurance by an insurer not otherwise authorized to transact business in New Mexico. This policy is not subject to supervision, review or approval by the superintendent of insurance. The insurance so provided is not within the protection of any guaranty fund law of New Mexico designed to protect the public in the event of the insurer's insolvency. \n \n",
                alignment: "justify"
            },
            {
                text: "POLICY NUMBER: %masterPolicyId% \n \n",
                alignment: "justify"
            },
            {
                text: "NAME OF INSURED: %assuredName% \n \n",
                alignment: "justify"
            },
            {
                text: "CERTIFICATE NUMBER: %certificateNumber% \n \n",
                alignment: "justify"
            },
            {
                text: "DATE POLICY SIGNED: %purchasedDate% \n \n",
                alignment: "justify"
            },
            {
                text: "UNDERWRITING COMPANY: %underwriterName% \n \n",
                alignment: "justify"
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true,
        insuranceLicenseSignature: true
    },
    {
        country: "USA",
        state: "NY",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "THE INSURER(S) NAMED HEREIN IS (ARE) NOT LICENSED BY THE STATE OF NEWYORK, NOT SUBJECT TO ITS SUPERVISION, AND IN THE EVENT OF THE INSOLVENCY OF THE INSURER(S), NOT PROTECTED BY THE NEW YORK STATE SECURITY FUNDS. THE POLICY MAY NOT BE SUBJECT TO ALL OF THE REGULATIONS OF THE DEPARTMENT OF FINANCIAL SERVICES PERTAINING TO POLICY FORMS; \n\n",
                alignment: "justify"
            },
            {
                text: "THIS INSURER IS NOT LICENSED IN THE STATE OF NEW YORK AND IS NOTSUBJECT TO ITS SUPERVISION. \n\n",
                alignment: "justify"
            },
            {
                text: "Policy must NOT be issued prior to ELANY reviewing the dox and applying the state stamp. Compliance (Duanne) will submit the policy dec and required affidavit to the state then return stamped dec to underwriter upon receipt from state (typically takes between 2-4 days).",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "NC",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "16px" }), formatTableColumnText([
            {
                text: "The insurance company with which this coverage has been placed is not licensed by the State of North Carolina and is not subject to its supervision. In the event of the insolvency of the insurance company, losses under this policy will not be paid by any State insurance guaranty or solvency fund.",
                alignment: "justify",
                bold: true,
                decoration: "underline"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "ND",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "22px", pageBreak: "before" }), formatTableColumnText([
            {
                text: "Notice: \n\n",
                alignment: "justify"
            },
            {
                text: "1. An insurer that is not licensed in this state is issuing the insurance policy that you have applied to purchase. These companies are called “nonadmitted” or “surplus lines” insurers. \n\n",
                alignment: "justify"
            },
            {
                text: "2. The insurer is not subject to the financial solvency regulation and enforcement that applies to licensed insurers in this state. \n\n",
                alignment: "justify"
            },
            {
                text: "3. These insurers generally do not participate in insurance guaranty funds created by state law. These guaranty funds will not pay your claims or protect your assets if the insurer becomes insolvent and is unable to make payments as promised. \n\n",
                alignment: "justify"
            },
            {
                text: "4. Some states maintain lists of approved or eligible surplus lines insurers and surplus lines producers may use only insurers on the lists. Some states issue orders that particular surplus lines insurers cannot be used. \n\n",
                alignment: "justify"
            },
            {
                text: "5. For additional information about the above matters and about the insurer, you should ask questions of your insurance producer or surplus lines producer. You may also contact your insurance department consumer help line.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "OH",
        variables: ["assuredName"],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "THE INSURANCE HEREBY EVIDENCED IS WRITTEN BY AN APPROVED NON-LICENSED INSURER IN THE STATE OF OHIO AND IS NOT COVERED IN CASE OF INSOLVENCY BY THE OHIO INSURANCE GUARANTY ASSOCIATION. \n\n",
                alignment: "justify"
            },
            {
                text: "Except when exempt from due diligence requirements under division (B) of this section, an insurance agent who procures or places insurance through a surplus lines broker shall obtain a signed statement from the insured acknowledging that the insurance policy is to be placed with a company or insurer not authorized to do business in this state and acknowledging that, in the event of the insolvency of the insurer, the insured is not entitled to any benefits or proceeds from the Ohio insurance guaranty association. The statement must be on a form prescribed by the superintendent and need not be notarized. The agent shall submit the original signed statement to the surplus lines broker within thirty days after the effective date of the policy. If no other agent is involved, the surplus lines broker shall obtain the statement from the insured. The surplus lines broker shall maintain the original signed statement or a copy of the statement, and the originating agent shall keep a copy of the statement, for at least five years after the effective date of the policy to which the statement pertains. A copy of the signed statement shall be given to the insured at the time the insurance is bound or a policy is delivered: “The named insured %assuredName%, acknowledges that the insurance policy (other than life insurance) as described above is to be placed with an insurance company not authorized to do business in Ohio. The insured understands that the insurance company is not a member of the Ohio Insurance Guaranty Association and that Chapter 3955 of the Ohio Revised Code is not applicable to claimants or insureds of said insurance company. The surplus line broker shall collect the Ohio tax of five percent of the amount of the premium for the insurance policy at the time the insurance policy is delivered to the insured”. \n\n",
                alignment: "justify"
            },
            {
                text: "Signature of Insured: ",
                alignment: "justify"
            },
            {
                text: "                                        ",
                decoration: "underline"
            }
        ]))
    },
    {
        country: "USA",
        state: "OK",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This contract not subject to the protection of any guaranty association in the event of liquidation or receivership of the surplus lines insurer.",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "OR",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This insurance was procured and developed under the Oregon surplus lines laws. It is NOT covered by the provisions of ORS 734.510 to 734.710 relating to the Oregon Insurance Guaranty Association. If the insurer issuing this insurance becomes insolvent, the Oregon Insurance Guaranty Association has no obligation to pay claims under this insurance.",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "PA",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "21px" }), formatTableColumnText([
            {
                text: "(1)  the insurer with which the licensee places the insurance is not licensed by the department and is subject to its limited regulation; and \n\n",
                alignment: "justify"
            },
            {
                text: "(2)  in the event of the insolvency of an eligible surplus lines insurer, losses will not be paid by the Pennsylvania Property and Casualty Insurance Guaranty Association. \n\n",
                alignment: "justify"
            },
            {
                text: "“The insurer which has issued this insurance is not licensed by the Pennsylvania Insurance Department and is subject to limited regulation. This insurance is NOT covered by the Pennsylvania Property and Casualty Insurance Guaranty Association.” \n\n",
                alignment: "justify"
            },
            {
                text: "PRIVACY NOTICE \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "“NEITHER THE U. S. BROKERS THAT HAVE HANDLED THIS INSURANCE NOR THE INSURERS THAT HAVE UNDERWRITTED THIS INSURANCE WILL DISCLOSE NONPUBLIC PERSONAL FINANCIAL INFORMATION CONCERNING THE BUYER TO NONAFFILIATED THIRD PARTIES EXCEPT AS PERMITTED BY LAW.”",
                alignment: "justify"
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "RI",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "NOTICE \n\n THIS INSURANCE CONTRACT HAS BEEN PLACED WITH AN INSURER NOT LICENSED TO DO BUSINESS IN THE STATE OF RHODE ISLAND BUT APPROVED AS A SURPLUS LINES INSURER. THE INSURER IS NOT A MEMBER OF THE RHODE ISLAND INSURERS INSOLVENCY FUND. SHOULD THE INSURER BECOME INSOLVENT, THE PROTECTION AND BENEFITS OF THE RHODE ISLAND INSURERS INSOLVENCY FUND ARE NOT AVAILABLE.",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "SC",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This company has been approved by the director or his designee of the South Carolina Department of Insurance to write business in this State as an eligible surplus lines insurance, but it is not afforded guaranty fund protection.",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "SD",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "THIS INSURANCE CONTRACT IS ISSUED BY A NONADMITTED INSURER WHICH IS NOT LICENSED BY NOR UNDER THE JURISDICTION OF THE SOUTH DAKOTA INSURANCE DIRECTOR.",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "TN",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This insurance contract is with an insurer not licensed to transact insurance in this state and is issued and delivered as a surplus lines coverage pursuant to the Tennessee insurance statutes. \n\n",
                alignment: "justify",
                bold: true
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "TX",
        variables: [],
        content: [
            Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
                {
                    text: "Guaranty Fund Nonparticipation Notice \n\n",
                    alignment: "center",
                    bold: true
                },
                {
                    text: "This insurance contract is with an insurer not licensed to transact insurance in this state and is  issued and delivered as surplus line coverage under the Texas insurance statutes. The Texas  Department of Insurances does not audit the finances or review the solvency of the surplus lines  insurer providing this coverage, and the insurer is not a member of the property and casualty  insurance guaranty association created under Chapter 462, Insurance Code. Chapter 225,  Insurance Code, requires payment of a 4.85% percent tax on gross premium. \n\n",
                    alignment: "justify"
                }
            ])),
            Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
                {
                    text: "Have a complaint or need help? \n\n",
                    alignment: "center",
                    bold: true
                },
                {
                    text: "If you have a problem with a claim or your premium, call your insurance company first. If you can't  work out the issue, the Texas Department of Insurance may be able to help. \n\n",
                    alignment: "justify"
                },
                {
                    text: "Even if you file a complaint with the Texas Department of Insurance, you should also file a complaint or appeal through your insurance company. If you don't, you may lose your right to appeal. \n\n",
                    alignment: "justify"
                },
                {
                    text: "Ursus Insurance Services Inc. \n ",
                    alignment: "justify",
                    bold: true
                },
                {
                    text: "To get information or file a complaint with your insurance company: \n\n",
                    alignment: "justify"
                },
                {
                    text: "\tCall: Ursus Insurance Services Inc. at 303-578-2440 \n",
                    alignment: "justify",
                    bold: true,
                    preserveLeadingSpaces: true
                },
                {
                    text: "\n\tEmail: complaints@loadsure.net \n\tMail: Ursus Insurance Services Inc \n\t470 James St., STE 7 \n\tNew Heaven, CT, 06513\n\n",
                    alignment: "justify",
                    preserveLeadingSpaces: true
                },
                {
                    text: "The Texas Department of Insurance \n",
                    alignment: "justify",
                    bold: true
                },
                {
                    text: "To get help with an insurance question or file a complaint with the state: \n\n",
                    alignment: "justify",
                    preserveLeadingSpaces: true
                },
                {
                    text: "\tCall with a question: (800) 681-5848 (option 1) \n\tFile a complaint: www.tdi.texas.gov \n\tEmail: ConsumerProtection@tdi.texas.gov \n\tMail: MC:CO-CP, Texas Department of Insurance, P.O. Box 12030, Austin, TX 78711-2030.",
                    alignment: "justify",
                    bold: true,
                    preserveLeadingSpaces: true
                }
            ]))
        ],
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "UT",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "The insurer issuing this policy does not hold a certificate of authority to do business in this state and thus is not fully subject to regulation by the Utah insurance commissioner. This policy receives no protection from any of the guaranty associations created under Title 31A, Chapter 28, Guaranty Associations",
                alignment: "justify"
            }
        ]))
    },
    {
        country: "USA",
        state: "VT",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px", color: "#FF0000" }), formatTableColumnText([
            {
                text: "The company issuing this policy is a surplus lines insurer and the rates charged have not been approved by the Commissioner of Financial Regulation. Any default on the part of the insurer is not covered by the Vermont Insurance Guaranty Association. \n\n",
                alignment: "justify",
                bold: true
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "VA",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "NOTICE TO INSURED \n\n",
                alignment: "justify"
            },
            {
                text: "THE INSURANCE POLICY THAT YOU HAVE APPLIED FOR HAS BEEN PLACED WITH OR IS BEING OBTAINED FROM AN ELIGIBLE NONADMITTED INSURER APPROVED BY THE STATE CORPORATION COMMISSION FOR ISSUANCE OF SURPLUS LINES INSURANCE IN THE COMMONWEALTH.  THEREFORE, YOU, THE POLICYHOLDER, AND PERSONS FILING A CLAIM AGAINST YOU ARE NOT PROTECTED UNDER THE VIRGINIA PROPERTY AND CASUALTY INSURANCE GUARANTY ASSOCIATION ACT (§§ 38.2-1600 et seq.) OF THE CODE OF VIRGINIA AGAINST DEFAULT OF THE COMPANY DUE TO INSOLVENCY.  IN THE EVENT OF INSURANCE COMPANY INSOLVENCY YOU MAY BE UNABLE TO COLLECT ANY AMOUNT OWED TO YOU BY THE COMPANY REGARDLESS OF THE TERMS OF THIS INSURANCE POLICY, AND YOU MAY HAVE TO PAY FOR ANY CLAIMS MADE AGAINST YOU. \n\n",
                alignment: "justify"
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "WA",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This contract is registered and delivered as a surplus line coverage under the insurance code of the state of Washington, Title 48 RCW. It is not protected by any Washington state guaranty association law.",
                alignment: "justify",
                bold: true
            }
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "WV",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "21px" }), formatTableColumnText([
            {
                text: "THIS COMPANY IS NOT LICENSED TO DO BUSINESS IN WEST VIRGINIA AND IS NOT SUBJECT TO THE WEST VIRGINIA INSURANCE GUARANTY ACT. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "Notice: \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "1. An insurer that is not licensed in this state is issuing the insurance policy that you have applied to purchase. These companies are called 'nonadmitted' or 'surplus lines' insurers. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "2. The insurer is not subject to the financial solvency regulation and enforcement that applies to licensed insurers in this state. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "3. These insurers generally do not participate in insurance guaranty funds created by state law. These guaranty funds will not pay your claims or protect your assets if the insurer becomes insolvent and is unable to make payments as promised. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "4. Some states maintain lists of approved or eligible surplus lines insurers and surplus lines brokers may use only insurers on the lists. Some states issue orders that particular surplus lines insurers cannot be used. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "5. For additional information about the above matters and about the insurer, you should ask questions of your insurance agent or surplus lines licensee. You may also contact your insurance commission consumer help line. \n\n",
                alignment: "justify",
                bold: true
            },
            {
                text: "This notice is supposed to be signed by the assured (Perhaps we can set up an acknowledgment field on the portal)",
                alignment: "justify",
                bold: true
            }
        ]))
    },
    {
        country: "USA",
        state: "WI",
        variables: [],
        content: Object.assign(Object.assign({}, exports.defaultStyle), formatTableColumnText([
            {
                text: "This insurance contract is with an insurer which has not obtained a certificate of authority to transact a regular insurance business in the state of Wisconsin, and is issued and delivered as a surplus line coverage pursuant to s. 618.41 of the Wisconsin Statutes. Section 618.43 (1), Wisconsin Statutes, requires payment by the policyholder of 3 percent tax on gross premium \n\n",
                alignment: "justify"
            },
            ...defaultUrsusInformation
        ])),
        insuranceLicenseName: true
    },
    {
        country: "USA",
        state: "WY",
        variables: [],
        content: Object.assign(Object.assign(Object.assign({}, exports.defaultStyle), { fontSize: "13px" }), formatTableColumnText([
            {
                text: "This insurance contract is issued pursuant to the Wyoming Nonadmitted Insurance Laws by an insurer neither licensed by nor under the jurisdiction of the Wyoming Insurance Department. In the event of insolvency of the surplus lines insurer, losses will not be paid by the Wyoming Insurance Guaranty Association or the Wyoming Life and Health Insurance Guaranty Association",
                alignment: "justify",
                bold: true
            }
        ]))
    }
];
//# sourceMappingURL=stateMasterLangEn.js.map